import Api from '@barboxx/api';
import { UserTypes } from '@barboxx/types';
import type { Authentication } from '@barboxx/models/types';

import { AuthService, AuthServiceConfigFunctions } from '../providers';
import { createAuthentication } from './authentication';

export interface UserAuthenticationConfig
    extends AuthServiceConfigFunctions<Authentication.UserAuthReturn> {
    allowedUserTypes?: UserTypes[];
    onLogOut?: () => Promise<void>;
}

export function createUserAuthentication({
    allowedUserTypes,
    onLogOut,
    ...restConfig
}: UserAuthenticationConfig = {}) {
    const userAuthService: AuthService<Authentication.UserAuthReturn> = {
        login: data =>
            Api.Authentication.Users.login(data).then(results => {
                if (results.ok && results.data) {
                    if (
                        allowedUserTypes &&
                        results.data.user.userType &&
                        !allowedUserTypes.includes(results.data.user.userType)
                    ) {
                        throw Error('User not authorized to login');
                    }
                    return results.data;
                } else {
                    throw Error('Login error');
                }
            }),

        logout: async () => {
            await onLogOut?.();
            return Api.Authentication.Users.logout().then();
        },
        refreshExpiredToken: query =>
            Api.Authentication.Users.refreshExpiredToken(query).then(result => {
                if (result.ok && result.data) {
                    return result.data;
                } else {
                    throw Error('Refresh token error');
                }
            }),
        hasRefreshToken: () => new Promise(resolve => resolve(true)),
        ...restConfig,
    };

    return createAuthentication<Authentication.UserAuthReturn>(userAuthService);
}
